// Components/ChatContacts/components/ContactsList.jsx
import React from "react";
import { List } from '@mui/material';
import ContactItem from "./ContactItem";

const ContactsList = ({
    listRef,
    contacts,
    setContactRef,
    isContactLoading,
    isContactLoaded,
    selectUser,
    isMobile,
    contactActive
}) => {
    return (
        <List
            ref={listRef}
            sx={{
                flex: 1,
                overflowY: 'auto',
                padding: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            {contacts.map((contact) => (
                <ContactItem
                    key={contact.id}
                    contact={contact}
                    isLoading={isContactLoading(contact.id)}
                    isLoaded={isContactLoaded(contact.id)}
                    setContactRef={setContactRef}
                    selectUser={selectUser}
                    isMobile={isMobile}
                    isActive={contactActive && contactActive.idContact === contact.id}
                />
            ))}
        </List>
    );
};

export default ContactsList;